import styled from "styled-components";
import {HiOutlineCheck, HiOutlineHeart, HiOutlineShieldCheck,} from "react-icons/hi";

export const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

export const Condition = styled.div`
  font-size: 14px;
  color: var(--gray);
  margin-bottom: 16px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;

  > h1 {
    width: 100%;
    font-size: 26px;
    font-weight: 600;
  }
`;

export const HeartIcon = styled(HiOutlineHeart)`
  width: 28px;
  height: 28px;
  color: #7049F6;
  margin-left: 16px;

  cursor: pointer;
`;

export const DispatchTag = styled.div`
  margin-top: 12px;
  background: #7049F6;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  width: fit-content;
`;

export const PriceCard = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  max-width: 100px;
  color: var(--color-gray);
  
  &.adjuste-bottom-margin-product-action {
    margin-bottom: -20px;
  }
  
  .container-price-row {
    margin-top: -7px;
  }

  .cut {
    position: relative;
  }

  .cut:before {
    position: absolute;
    content: "";
    left: 0;
    top: 50%;
    right: 0;
    border-top: 1px solid;
    border-color: inherit;
    color: red;

    -webkit-transform: rotate(-5deg);
    -moz-transform: rotate(-5deg);
    -ms-transform: rotate(-5deg);
    -o-transform: rotate(-5deg);
    transform: rotate(-5deg);
  }
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 44px;
  font-weight: 300;

  &.adjust-bottom {
    margin-bottom: -25px;
  }

  &.min {
    font-size: 25px;
  }

  .symbol {

    color: #6E4FF3;

    &.min {
      font-size: 25px;
      color: #909090;
    }
  }

  .fraction {
    color: #6E4FF3;
    margin-left: 8.8px;

    &.min {
      font-size: 25px;
      color: #909090;
    }

    &.del {
      position: relative;

      &:before {
        content: " ";
        width: 160%;
        border-top: 1px solid #ec0606;
        height: 9px;
        position: absolute;
        bottom: 20px;
        left: 0;
        transform: rotate(160deg);
      }
    }
  }

  .cents {
    color: #6E4FF3;
    font-size: 20px;
    padding-top: 3px;
    margin-left: 1px;

    &.min {
      font-weight: 700;
      font-size: 15px;
      color: #909090;
    }
  }
`;

export const InstallmentsInfo = styled.div`
  font-size: 16px;
`;

export const StockStatus = styled.div`
  margin-top: 24px;
  font-size: 18px;
`;

export const MethodCard = styled.div`
  margin-top: 18px;
  display: flex;

  .sale-delivery-time {
    color: #6E4FF3;
    font-weight: 700;
    font-size: 15px;
    display: flex;
    align-items: center;
    margin-top: -15px;
  }
  
  > div {
    margin-left: 8px;
    display: flex;
    flex-direction: column;

    .title {
      color: var(--color-green);
      font-size: 16px;
    }

    .details {


      margin-top: -15px;
      color: #905050;
      font-weight: 700;
      font-size: 15px;
    }

    .more {
      margin-top: 5px;
      font-size: 14px;
      font-weight: 600;
      text-decoration: none;
      color: #7049F6;
    }
  }
`;

export const CheckIcon = styled(HiOutlineCheck)`
  width: 24px;
  height: 24px;
  color: var(--color-green);
`;

export const Actions = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`;

type ButtonProps = { solid?: boolean };

export const Button = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 15px;
  border-radius: 4px;
  padding: 12px 10px;
  margin-top: 10px;

  color: ${(props) =>
          props.solid ? "#fff" : "#7049F6"};
  background: ${(props) => (props.solid ? "#7049F6" : "transparent")};
  border: ${(props) => (props.solid ? "none" : "1px solid #7049F6")};

  cursor: pointer;
`;

export const Benefits = styled.ul`
  margin-top: 16px;
  list-style: none;
  display: flex;
  flex-direction: column;

  > li {
    display: flex;

    p {
      margin-left: 10px;
      color: var(--color-gray);
      font-size: 14px;
    }
  }
  
  .fb-share-button {
    margin-top: 5px;
    opacity: 0;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
  }
`;

export const ShieldIcon = styled(HiOutlineShieldCheck)`
  width: 20px;
  height: 20px;
  color: var(--color-gray);
  flex-shrink: 0;
`;
